import i18n from '@/utils/i18n';
import React from 'react';
import { Button, ButtonSize } from '@sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';

interface Props {
  onPress: () => void;
}

export const PricingReviewButton: React.FC<Props> = ({ onPress }) => {
  const [styles] = useStyles();

  return (
    <Button
      accessibilityLabel={i18n.t('pricing.go_to_review.cta')}
      onPress={onPress}
      size={ButtonSize.Small}
      style={styles.button}
    >
      {i18n.t('pricing.go_to_review.cta')}
    </Button>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
